// extracted by mini-css-extract-plugin
export default {"wide":"W5b45","wide--wait":"CLBnV","wide__header":"a4Brw","wide__header--dark":"lVDtW","wide__body":"gENh4","price":"rOCqs","badge":"GWsTJ"};